import { Component, ChangeDetectionStrategy } from '@angular/core'
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import { LoadingService } from '@app/core'
import { NotificationService } from '@app/core/services/notification.service'
import { Observable } from 'rxjs'
import { ConfirmEmailService } from '@app/session/services/confirm-email.service'

@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ConfirmEmailComponent {
  form: FormGroup<{ email: FormControl<string> }>

  isLoading$: Observable<boolean>

  constructor(
    private confirmEmailService: ConfirmEmailService,
    private router: Router,
    private notificationService: NotificationService,
    loadingService: LoadingService,
    formBuilder: FormBuilder,
  ) {
    this.isLoading$ = loadingService.isLoading$

    this.form = formBuilder.group({
      email: ['', Validators.email],
    })
  }

  get email(): AbstractControl {
    return this.form.get('email')
  }

  onSubmit(form): void {
    this.confirmEmailService.confirmEmail(form.email)

    this.notificationService.success('UI.ConfirmEmail.Message.MailSendSuccess', null, { duration: 30000 })
    this.router.navigateByUrl('/login')
  }
}
